import { graphql, useStaticQuery } from 'gatsby';

import isDefined from '../utils/isDefined';
import type { Lucid } from '../types/types';

type FeatureFlagReturnObject = { [key: string]: Lucid.FeatureFlag.BaseConfig };

const useFeatureFlags = (testName?: string) => {
  const { allFeatureFlag } = useStaticQuery<Lucid.FeatureFlag.Query>(graphql`
    {
      allFeatureFlag {
        edges {
          node {
            description
            defaultBranch
            isActive
            lastFetched
            modifiedDate
            name
            variations {
              T_A
              T_AN
              T_B
              T_C
              T_D
            }
          }
        }
      }
    }
  `);

  const { edges } = allFeatureFlag;
  const filteredFeatureFlags = edges.filter(isDefined);

  const allFeatureFlags = filteredFeatureFlags.reduce<FeatureFlagReturnObject>((previous, current) => {
    const { name } = current.node;
    if (testName && testName === name) {
      return {
        [name]: current.node,
      };
    }

    if (name && !testName) {
      return {
        ...previous,
        [name]: current.node,
      };
    }

    return previous;
  }, {} as FeatureFlagReturnObject);

  return allFeatureFlags;
};

export default useFeatureFlags;
